import React from 'react';

import Inputs from '../../../components/InsuranceInputs';
import InsuranceSteps from '../../../components/InsuranceSteps';
import HeaderTitle from './HeaderTitle';
import { WrapperHeaderBlock } from '../styles';
import { 
  InsuranceParameters, 
  IInsurance, 
  SetInsuranceParameters, 
  SetInsurance 
} from '../../../types';

type Props = {
  insurance: IInsurance;
  insuranceParameters?: InsuranceParameters;
  setInsuranceParameters?: SetInsuranceParameters;
  setInsurance: SetInsurance; 
}

const HeaderBlock: React.FC<Props> = (
  { 
    insuranceParameters, 
    insurance, 
    setInsuranceParameters,
    setInsurance 
  }) => {
    return (
      <WrapperHeaderBlock>
        <HeaderTitle />
        <InsuranceSteps />
        <Inputs
          insurance={insurance}
          insuranceParameters={insuranceParameters}
          setInsuranceParameters={setInsuranceParameters}
          setInsurance={setInsurance}
        />
      </WrapperHeaderBlock>
    );
};

export default HeaderBlock;
